import React from 'react';
import { connect } from 'react-redux';
import { create } from '../Actions/employee';
import Routes from '../Shared/routes';
import AddEmployee from '../Components/Employee/Item';
import { EMAIL_IS_INVALID, FILL_PARAMS_ERROR } from '../Shared/errors';
import { IEmployeeEdit } from '../Shared/interfaces';
import { isEmailValid } from '../Shared/utils';


interface IProps {
    isLoading: boolean;
    error: number | null;
    getList: () => void;
    create: (data: IEmployeeEdit) => void;
    history: any;
}

interface IState {
    error: number | null;
}

class AddEmployeePage extends React.Component<IProps, IState> {

    state = {
        error: null
    }

    onSubmit = async (data: IEmployeeEdit) => {
        if (!data.name || !data.email || !data.password) {
            this.setState({
                error: FILL_PARAMS_ERROR
            })
        }
        else if(!isEmailValid(data.email)){
            this.setState({
                error: EMAIL_IS_INVALID
            });
        }
        else {
            await this.props.create(data);
            if (!this.props.error) {
                this.props.history.push(Routes.EMPLOYEE_LIST)
            }
        }
    }

    render() {
        return (
            <AddEmployee
                error={this.props.error || this.state.error}
                isLoading={this.props.isLoading}
                onSubmit={this.onSubmit}
            />
        );
    }
}

function bindAction(dispatch: any) {
    return {
        create: (data: IEmployeeEdit) => dispatch(create(data))
    };
}

const mapStateToProps = (state: any) => {
    return {
        isLoading: state.employee.isLoading,
        error: state.employee.error
    }
}

export default connect(
    mapStateToProps,
    bindAction
)(AddEmployeePage);
